import React from "react";
import clsx from "clsx";
import styles from "./Icon.module.css";
import * as Icons from "./icons";

export enum IconSize {
  nano = "nano",
  mini = "mini",
  tiny = "tiny",
  small = "small",
  medium = "medium",
  large = "large",
  big = "big",
  huge = "huge",
  massive = "massive",
}

export type IconNames = keyof typeof Icons;

export interface IconProps {
  className?: string;
  name: IconNames;
  circular?: boolean;
  primary?: boolean;
  secondary?: boolean;
  negative?: boolean;
  size?: IconSize;
  rotateDeg?: number;
  onClick?: () => unknown;
  loading?: boolean;
  pulse?: boolean;
  title?: string;
  color?: string;
  as?: React.ElementType;
}

const Icon: React.FC<IconProps> = ({
  className,
  name,
  circular,
  primary,
  secondary,
  negative,
  size,
  loading,
  pulse,
  rotateDeg = 0,
  as = "span",
  onClick,
  title,
  color,
}) => {
  const Component = Icons[name];

  return React.createElement(
    as,
    {
      className: clsx(
        styles.container,
        size ? styles[size] : "",
        circular ? styles.circular : "",
        primary ? styles.primary : "",
        secondary ? styles.secondary : "",
        negative ? styles.negative : "",
        loading ? styles.loading : "",
        pulse ? styles.pulse : "",
        className,
      ),
      style: {
        transform: `rotateZ(${rotateDeg}deg)`,
        ...(color ? { "--icon-color": color } : {}),
      },
      onClick,
      title: title ?? name,
    },
    <Component className={styles.icon} />,
  );
};

export default Icon;
